const SEARCH_URL_BASE = 'https://www.harborcapital.com'

export const getPathKey = (url) => {
  if (typeof url !== 'string' || !url.trim()) return null

  try {
    const rawUrl = url.trim()
    const parsedUrl = new URL(rawUrl, SEARCH_URL_BASE)

    if (!['http:', 'https:'].includes(parsedUrl.protocol)) return null

    const pathname = parsedUrl.pathname.replace(/\/+/g, '/').toLowerCase()
    const normalizedPath = pathname.startsWith('/') ? pathname : `/${pathname}`

    if (normalizedPath === '/') return '/'
    return normalizedPath.replace(/\/+$/, '') || '/'
  } catch {
    return null
  }
}
